<template>
  <IconButton icon="eye" title="Preview" @click="show = true" :small="small" />
  <LetterPreviewModal v-model="show" :letters="letters" :context="context" @print="$emit('print')" />
</template>

<script>
import IconButton from "@/components/common/IconButton.vue";
import Correspondence from "@/models/Correspondence";
import LetterPreviewModal from "@/components/letters/LetterPreviewModal.vue";
import {LetterContext} from "@/models/letterContext";

export default {
  components: {LetterPreviewModal, IconButton},
  emits: ['print'],
  props: {
    letters: {
      type: Array,
      required: true,
      validator: (arr) =>
        Array.isArray(arr) && arr.every((x) => x instanceof Correspondence)
    },
    context: LetterContext,
    small: Boolean
  },
  data() {
    return {
      show: false
    };
  }
}
</script>
